/** * @author SwathiDivya Bhavaraju * @email SwathiDivya.Bhavaraju@ul.com *
@create date 2019-08-08 14:17:28 * @modify date 2019-08-08 14:17:28 * @desc
[description] */
<template>
  <div
    class="scroll-dashboard-div dashboard-container content-wrappper"
    v-on:scroll="deactivatePopover"
  >
    <div class="row">
      <summary-card
        :widgetTrackplusFlag="widgetTrackplusFlag"
        :registrationCount="registrationCount"
        :devicesCount="devicesCount"
        :countriesCount="countriesCount"
      ></summary-card>
      <expiration-card
        :widgetTrackplusFlag="widgetTrackplusFlag"
        :expiration_details="expiration_details"
        :expiryVisible="expiryVisible"
        :openPopover="openPopover"
        @viewRegistration="viewRegistration"
      ></expiration-card>
      <pending-card
        :widgetTrackplusFlag="widgetTrackplusFlag"
        :pending_summary="pending_summary"
        :pendingVisible="pendingVisible"
        :openPopover="openPopover"
        @viewRegistration="viewRegistration"
      ></pending-card>
    </div>
    <div class="row MT-25">
      <div class="col-xs-12 col-md-12 col-lg-12 p-15">
        <!-- <div class="p-15"> -->
        <new-map-view
          :roleId="roleId"
          :permissions="permissions"
          @setMapData="setMapData"
          @viewRegistration="viewRegistration"
          @exportDocumentId="exportPopup"
        ></new-map-view>
        <registration-details-popup
          :permissions="permissions"
          :dataRow="activeRegistration"
          @hidePopup="hidePopup"
          :reportFlag="true"
        ></registration-details-popup>
        <!-- </div> -->
      </div>
    </div>
    <permission-access-modal></permission-access-modal>
    <export-popup
      :documentId="documentId"
      @resetExportPopup="resetExportPopup"
      :mapData="mapData"
    ></export-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
// import cloneDeep from 'lodash/cloneDeep';
import $ from 'jquery';
import * as d3 from 'd3v4';
import NewMapView from '../UIComponents/NewMapView.vue';
import registrationDetailsPopup from '../Registrations/RegistrationDetailsPopup.vue';
import vSelect from '../UIComponents/TrackPlusSelect.vue';
import Loader from '../UIComponents/Loader.vue';
import PermissionAccessModal from '../Common/PermissionAccessModal.vue';
import { getChartsDataOverView } from '../../apis/reports';
import { getDashboardSummary } from '../../apis/dashboard';
import { getRegistrationDetailsById } from '../../apis/registrations';
import constructRegistrationObject from '../../utils/registrationDetails';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import ExportPopup from '../Common/ExportPopup.vue';
import SummaryCard from './SummaryCard.vue';
import ExpirationCard from './ExpirationCard.vue';
import PendingCard from './PendingCard.vue';

export default {
  mixins: [permissionsList],
  props: ['roleId'],
  data() {
    return {
      widgetTrackplusFlag: true,
      permissions: [],
      loaderStatus: false,
      registrationCount: 0,
      devicesCount: 0,
      countriesCount: 0,
      charts: [],
      errors: [],
      ViewCountryList: false,
      mode: 'reports',
      editFlag: '',
      activeRegistration: {},
      actualProductData: [],
      data: [],
      registrationdata: [],
      productList: [],
      dataProduct: [],
      dataMapProduct: [],
      mapProductList: [],
      registrationIdList: [],
      mapRegistrationIdList: [],
      productDropDownLabel: 'All',
      mapProductDropDownLabel: 'All',
      marginTitle: 0,
      expiration_details: {},
      pending_summary: {},
      expiryVisible: [false, false, false, false],
      pendingVisible: [false, false, false],
      openPopover: false,
      clickPopover: false,
      mapData: [],
      mapDataloaded: false,
      country: '',
      countryList: [],
      disabledClrBtn: true,
      listView: false,
      isIslands: false,
      isExport: false,
      isProductSelected: false,
      isCountrySelected: false,
      isCheckedCounter: 0,
      worldMapId: 'worldMap',
      tablelistChartId: 'tableListChart',
      documentId: ''
    };
  },
  components: {
    NewMapView,
    PermissionAccessModal,
    Loader,
    registrationDetailsPopup,
    vSelect,
    ExportPopup,
    SummaryCard,
    ExpirationCard,
    PendingCard
  },
  computed: {
    selectedMapCount() {
      return this.dataMapProduct.filter((dataObj) => dataObj.selected);
    }
  },
  methods: {
    setMapData(mapData) {
      this.mapData = mapData;
    },
    exportPopup(id) {
      this.documentId = id;
      $('#exportPdfImg').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    resetExportPopup() {
      this.documentId = '';
      $('#exportPdfImg').modal('hide');
    },
    countryLabel(country) {
      let countryName = country;
      if (window.innerWidth < 768 && country.length > 40) {
        const i = country.indexOf(' ', 30);
        countryName = `${country.substring(0, i)}<br>${country.substring(
          i + 1
        )}`;
      }
      return countryName;
    },
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    async viewRegistration(registrationId, type, index) {
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        if (this.roleId === 4) {
          return;
        }
        this.loaderStatus = true;
        if (type) {
          if (type === 'expiry') {
            this.expiryVisible[index] = false;
          } else {
            this.pendingVisible[index] = false;
          }
          const all = document.getElementsByClassName('popper-custom-class');
          for (let i = 0; i < all.length; i += 1) {
            all[i].style.display = 'none';
          }
        }
        const selectedRegistration = await getRegistrationDetailsById(
          registrationId
        );
        this.loaderStatus = false;
        if (selectedRegistration && selectedRegistration.error) {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification'
          });
        } else if (selectedRegistration) {
          this.activeRegistration =
            constructRegistrationObject(selectedRegistration);
          $('#registrationDetail').modal();
        }
      }
    },
    async getDashboardSummary() {
      this.loaderStatus = true;
      const {
        expiration_details: expirationDetails,
        pending_summary: pendingSummary
      } = await getDashboardSummary();
      this.pending_summary = pendingSummary;
      this.expiration_details = expirationDetails;
      this.loaderStatus = false;
    },
    async getChartsDataOverView() {
      const data = await getChartsDataOverView();
      this.registrationCount = data.noOfRegistrations;
      this.devicesCount = data.noOfDevices;
      this.countriesCount = data.noOfCountries;
    },
    filterCountryChartData(chartType) {
      let countryPresent = false;
      let newCountryObj = {};
      let statusListParam = '';
      this.data = [];
      this.mapData = [];
      const statusList = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      if (chartType === 'stack') {
        this.registrationdata.forEach((curRegistrationData) => {
          if (curRegistrationData.country_code === null) {
            return;
          }
          countryPresent = false;
          for (let i = 0; i < this.data.length; i += 1) {
            if (curRegistrationData.country_code === this.data[i].country) {
              for (let j = 0; j < statusList.length; j += 1) {
                if (
                  curRegistrationData.status.toLowerCase() ===
                    statusList[j].toLowerCase() &&
                  this.registrationIdList.indexOf(
                    curRegistrationData.registration_id
                  ) > -1
                ) {
                  this.data[i][statusList[j]] += 1;
                  statusListParam = `${statusList[j]
                    .split(' ')[0]
                    .toLowerCase()}_list`;
                  this.data[i][statusListParam].push({
                    id: curRegistrationData.registration_id,
                    name: curRegistrationData.product_name
                  });
                  break;
                }
              }
              this.data[i].totalRegistration += 1;
              countryPresent = true;
              break;
            }
          }
          if (
            countryPresent === false &&
            this.registrationIdList.indexOf(
              curRegistrationData.registration_id
            ) > -1
          ) {
            newCountryObj = {};
            newCountryObj.country = curRegistrationData.country_code;
            newCountryObj.countryName = curRegistrationData.country_name;
            for (let j = 0; j < statusList.length; j += 1) {
              newCountryObj[statusList[j]] = 0;
              statusListParam = `${statusList[j]
                .split(' ')[0]
                .toLowerCase()}_list`;
              newCountryObj[statusListParam] = [];
              if (
                curRegistrationData.status.toLowerCase() ===
                statusList[j].toLowerCase()
              ) {
                newCountryObj[statusList[j]] += 1;
                newCountryObj[statusListParam].push({
                  id: curRegistrationData.registration_id,
                  name: curRegistrationData.product_name
                });
              }
            }
            newCountryObj.totalRegistration = 1;
            this.data.push(newCountryObj);
          }
        });
        this.drawVerticalStackedBarChart();
      } else if (chartType === 'map') {
        this.registrationdata.forEach((curRegistrationData) => {
          if (curRegistrationData.country_code === null) {
            return;
          }
          countryPresent = false;
          for (let i = 0; i < this.mapData.length; i += 1) {
            if (curRegistrationData.country_code === this.mapData[i].country) {
              for (let j = 0; j < statusList.length; j += 1) {
                if (
                  curRegistrationData.status.toLowerCase() ===
                    statusList[j].toLowerCase() &&
                  this.mapRegistrationIdList.indexOf(
                    curRegistrationData.registration_id
                  ) > -1
                ) {
                  this.mapData[i][statusList[j]] += 1;
                  statusListParam = `${statusList[j]
                    .split(' ')[0]
                    .toLowerCase()}_list`;
                  this.mapData[i][statusListParam].push({
                    id: curRegistrationData.registration_id,
                    name: curRegistrationData.product_name
                  });
                  break;
                }
              }
              this.mapData[i].totalRegistration += 1;
              countryPresent = true;
              break;
            }
          }
          if (
            countryPresent === false &&
            this.mapRegistrationIdList.indexOf(
              curRegistrationData.registration_id
            ) > -1
          ) {
            newCountryObj = {};
            newCountryObj.country = curRegistrationData.country_code;
            newCountryObj.countryName = curRegistrationData.country_name;
            statusList.forEach((status) => {
              newCountryObj[status] = 0;
              statusListParam = `${status.split(' ')[0].toLowerCase()}_list`;
              newCountryObj[statusListParam] = [];
              if (
                curRegistrationData.status.toLowerCase() ===
                status.toLowerCase()
              ) {
                newCountryObj[status] += 1;
                newCountryObj[statusListParam].push({
                  id: curRegistrationData.registration_id,
                  name: curRegistrationData.product_name
                });
              }
            });
            newCountryObj.totalRegistration = 1;
            this.mapData.push(newCountryObj);
          }
        });
        this.DupMapData = this.mapData;
        this.drawWorldMap();
      }
    },

    drawVerticalStackedBarChart() {
      const parentWidth = this.$el.clientWidth;
      const margin = {
        top: 20,
        right: 40,
        bottom: 50,
        left: 40
      };
      const width = parentWidth / 1.5;
      const height = 300;

      this.marginTitle =
        (parentWidth - (width + margin.left + margin.right)) / 2;

      const legendWidth = 100;
      const legendRectSize = 9;
      const legendSpacing = 3;
      const statusList = ['Expired', 'Expiring soon', 'Pending', 'Active'];
      const statusColor = ['#ff0606', '#ffaa49', '#4f90c3', '#013a68'];

      d3.select('#stackedBarChartDiv svg').remove();

      const svg = d3
        .select('#stackedBarChartDiv')
        .append('svg')
        .attr('id', 'stackedBarChart')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom);

      // const isTooltipHovered = false;

      d3.select('.country-tooltip').html('');
      const divTooltip = d3.select('.country-tooltip');

      divTooltip.append('div').attr('class', 'header');
      divTooltip.append('div').attr('class', 'body');

      let statusId = '';
      statusList.forEach((status) => {
        statusId = status.split(' ')[0].toLowerCase();
        divTooltip
          .select('.body')
          .append('div')
          .attr('class', 'panel list-group')
          .attr('id', `${statusId}-panel`);
      });

      const g = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      const x = d3
        .scaleBand()
        .rangeRound([0, width - legendWidth])
        .padding(0.3)
        .align(0.3);

      const y = d3.scaleLinear().rangeRound([height, 0]);

      const z = d3
        .scaleOrdinal()
        .range(['#013a68', '#4f90c3', '#ffaa49', '#ff0606']);

      const keys = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      this.data.sort((a, b) => b.totalRegistration - a.totalRegistration);
      x.domain(this.data.map((d) => d.country));
      const yTop = d3.max(this.data, (d) => d.totalRegistration);
      const yMax = yTop <= 5 ? 5 : yTop;
      y.domain([0, yMax]).nice();
      // y.domain([0, d3.max(this.data, function(d) { return d.totalRegistration; })]).nice();
      z.domain(keys);

      // add the Y gridlines
      g.append('g')
        .attr('class', 'grid')
        .call(
          d3
            .axisLeft(y)
            .ticks(5, 's')
            .tickSize(-width + legendWidth)
            .tickFormat('')
        );

      g.selectAll('.grid line, .grid path')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const stack = d3
        .stack()
        .keys(keys.reverse())
        .order(d3.stackOrderNone)
        .offset(d3.stackOffsetNone);

      const series = stack(this.data);

      g.append('g')
        .selectAll('g')
        .data(series)
        .enter()
        .append('g')
        .attr('fill', (d) => z(d.key))
        .selectAll('rect')
        .data((d) => d)
        .enter()
        .append('rect')
        .attr('class', 'bar')
        .attr('x', (d) => x(d.data.country))
        .attr('y', (d) => y(d[1]))
        .attr('height', (d) => y(d[0]) - y(d[1]))
        .attr('width', x.bandwidth());

      g.selectAll('.bar')
        .on('mousemove', (d) => {
          const barLeft =
            parseFloat(d3.select(this).attr('x')) +
            parseFloat(svg.node().getBoundingClientRect().left) +
            parseFloat(d3.select(this).attr('width')) +
            50;
          divTooltip
            .style('left', `${barLeft}px`)
            .style('top', `${d3.event.pageY - 40}px`);

          d3.select('.tracker-map-tooltip .header').html(
            `<span class="flag-icon flag-icon-squared flag-icon-${d.data.country.toLowerCase()}"></span>${
              d.data.countryName
            }`
          );

          let statusLC = '';
          let linkStr = '';

          statusList.forEach((status, index) => {
            statusLC = status.split(' ')[0].toLowerCase();
            if (d.data[`${statusLC}_list`].length > 0) {
              d3.select(`#${statusLC}-panel`).html(
                `<a id="${statusLC}-group" class="list-group-item parent collapsed" data-toggle="collapse" data-target="#${statusLC}"></a><div id="${statusLC}" class="sublinks collapse"></div>`
              );
              d3.select(`#${statusLC}-group`).html(
                `${
                  d.data[`${statusLC}_list`].length
                } ${status.toLowerCase()} registrations:`
              );
              d3.select(`#${statusLC}-group`).style(
                'color',
                statusColor[index]
              );
              linkStr = '';
              d.data[`${statusLC}_list`].forEach((product) => {
                linkStr += `<a class="list-group-item small" slot="${product.id}">${product.name}</a>`;
              });
              d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                linkStr
              );
            } else {
              d3.select(`#${statusLC}-panel`).html('');
              d3.select(`#${statusLC}-group`).html('');
              d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                ''
              );
            }
          });

          d3.select('.tracker-map-tooltip').style('display', 'block');
        })
        .on('mouseout', () => {
          setTimeout(() => {
            d3.select('.tracker-map-tooltip').style('display', 'none');
          }, 700);
        });

      const xAxis = d3.axisBottom(x).tickSize(0);

      g.append('g')
        .attr('class', 'axis')
        .attr('transform', `translate(0,${height})`)
        .call(xAxis);

      g.selectAll('.tick text')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('fill', '#2185D0')
        .attr('y', '30');

      g.append('g')
        .attr('transform', 'translate(0, 0)')
        .attr('class', 'axis')
        .call(d3.axisLeft(y).ticks(5, 's').tickFormat(d3.format('d')))
        .append('text')
        .attr('x', 2)
        .attr('y', y(y.ticks().pop()) + 0.5)
        .attr('dy', '0.32em')
        .attr('fill', '#2185D0')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'start');

      g.selectAll('.tick text')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('fill', '#2185D0');

      g.selectAll('.axis path, .tick line')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const legend = svg
        .append('g')
        .attr('font-size', 10)
        .attr('text-anchor', 'start')
        .attr(
          'transform',
          `translate(${width - legendWidth + margin.left + 10},${margin.top})`
        )
        .selectAll('g')
        .data(keys.reverse())
        .enter()
        .append('g')
        .attr('transform', (d, i) => `translate(0,${i * 20})`);

      legend
        .append('rect')
        .attr('width', legendRectSize)
        .attr('height', legendRectSize)
        .attr('fill', z);

      legend
        .append('text')
        .style('font-size', '14px')
        .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('x', legendRectSize + legendSpacing + 4)
        .attr('y', legendRectSize - legendSpacing + 4)
        .text((d) => d);

      // Prep the tooltip bits, initial display is hidden
      const tooltip = g
        .append('g')
        .attr('class', 'toolTip')
        .style('display', 'none');

      tooltip
        .append('rect')
        .attr('width', 30)
        .attr('height', 20)
        .attr('fill', 'white');

      tooltip
        .append('text')
        .attr('x', 15)
        .attr('dy', '1.2em')
        .style('text-anchor', 'middle')
        .attr('font-size', '12px')
        .attr('font-weight', 'bold');

      this.loaderStatus = false;
    },
    closeModal(e) {
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      this.activeId = '';
      return true;
    },
    hidePopup(value) {
      this.editFlag = value;
    },
    activatePopover() {
      this.openPopover = false;
      this.clickPopover = true;
    },
    deactivatePopover() {
      if (window.scrollY && this.clickPopover) {
        this.openPopover = true;
      }
    },
    hidePopover() {
      this.clickPopover = false;
    }
  },
  async created() {
    await this.getDashboardSummary();
    await this.getChartsDataOverView();
    await this.validateFeatures();
    window.addEventListener('scroll', this.deactivatePopover);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.deactivatePopover);
  },
  mounted() {
    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
  }
};
</script>

<style scoped>
.p-r-10 {
  padding-right: 10px;
}
.va-middle {
  vertical-align: middle;
}
.ht-15 {
  height: 15px;
}
.islands-div {
  color: #606266;
  font-size: 12px;
  padding: 20px 10px 10px 0px;
}
.p-15 {
  padding: 15px;
}
.lt-20 {
  left: 20px;
}
.lt-30 {
  left: 30px;
}
.mt-5 {
  margin-top: 5px;
}
@media only screen and (min-width: 768px) {
  .lt-100 {
    left: 100px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mapIcon {
    left: 0px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 600px) {
  .rt-30 {
    right: 0 !important;
  }
  .rt-50 {
    right: 0 !important;
  }
  .mt-5-xs {
    margin-top: 5px;
  }
  .mt-10-xs {
    margin-top: 10px;
  }
  .rt-10-xs {
    right: 10px !important;
  }
}
@media only screen and (min-width: 992px) {
  .lt-100 {
    left: unset;
  }
  .mt-20 {
    margin-top: 0px;
  }
  .mapIcon {
    margin-top: 5px;
  }
  .toggle_map {
    left: 0px;
  }
}
@media (min-width: 1025px) and (max-width: 1300px) {
  .exportUL {
    float: right;
  }
}
@media only screen and (min-width: 1300px) {
  .country-dropdown {
    padding-left: 30px !important;
  }
}
@media only screen and (max-width: 1024px) {
  .content-wrappper .widget {
    margin-bottom: 20px !important;
  }
}
@media only screen and (max-width: 767px) {
  .mt-xs-10 {
    margin-top: 10px;
  }
  .country-dropdown {
    padding-left: 6px !important;
  }
  .list-title {
    font-size: 22px !important;
  }
  .p-xs {
    padding: 0px !important;
    font-size: 14px !important;
  }
  .table > thead > tr > th {
    padding: 0px !important;
  }
  .table > tbody > tr > td {
    font-size: 12px !important;
    padding-left: 0px !important;
    text-align: center;
  }
}
.dashboard-container {
  padding: 20px;
  font-family: Roboto;
  font-style: normal;
}

.widget {
  min-height: 280px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
  padding: 24px;
  background: #ffffff;
}

.MT-25 {
  margin-top: 25px;
}
.border_line .border_cls {
  border: 0.5px solid #0b3c61;
  margin-top: 25px;
}
.border_line {
  padding-right: 0px;
}
.export-menu {
  left: -39% !important;
}
.border_dot {
  padding-left: 0px;
}
.border_dot .border_cls {
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  margin-top: 23px;
}
.dashboard-container {
  background: #f2f2f2;
}
.rt-0 {
  right: 0;
}
.rt-10 {
  right: 10px;
}
.rt-30 {
  right: 30px;
}
.rt-50 {
  right: 50px;
}
.list-title {
  width: fit-content;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  /* Emergo Dark Blue */
  color: #0b3c61;
  margin-right: 8px;
  position: relative;
  bottom: 3px;
}
.table-title {
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}
.pl-0 {
  padding-left: 0px;
}
.pl-5 {
  padding-left: 5px;
}
.pb-25 {
  padding-bottom: 25px;
}
.pl-60 {
  padding-left: 60px !important;
}
.pl-80 {
  padding-left: 80px !important;
}
.map-controls-container {
  display: flex;
  padding-left: 25px;
  padding-right: 25px;
}

.dropdown-container {
  display: flex;
  width: 60%;
  justify-content: space-between;
}

.product-container,
.country-container {
  display: flex;
  width: 50%;
}

.product-container {
  margin-right: 32px;
}
.country-dropdown {
  padding-left: 0px !important;
  width: 80%;
}

.controls-container {
  display: flex;
  width: 40%;
  justify-content: flex-end;
}

.clear-button-wrapper {
  margin-right: 24px;
}

.export-btn {
  margin-right: 25px;
}
.pl-8 {
  padding-left: 8px !important;
}
.background_fff {
  background: #ffffff;
}
.country-border {
  border-bottom: 2px solid #828282;
}
.expired-border {
  border-bottom: 2px solid #eb5757;
}
.expiring-soon-border {
  border-bottom: 2px solid #f2994a;
}
.pending-border {
  border-bottom: 2px solid #9b51e0;
}
.active-border {
  border-bottom: 2px solid #f2c94c;
}
table,
td {
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
}
table,
.showMap {
  height: 470px;
}
table > tbody > tr {
  border-bottom: 0.5px solid #bdbdbd;
  border-collapse: collapse;
}
.table > thead > tr > th {
  border-bottom: none;
  cursor: default;
}
tbody {
  max-height: 470px;
  display: block;
  overflow-y: auto;
}
thead,
tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
h1 {
  font-size: 1.5em;
  text-align: center;
  color: #4f90c3;
  font-weight: lighter;
}

.dashboard_row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 20px;
}

.dashboard_cell {
  flex: 1 0 auto;
  border-radius: 5px;
  margin-left: 5px;
  margin-right: 5px;
  min-height: 190px;
  max-height: 190px;
  overflow: hidden;
  height: 190px;
  transition: all 200ms ease-in-out;
  width: 30%;
}

.red {
  background-color: #cf5f28;
}

.orange {
  background-color: #f2994a;
}

.dark_blue {
  background-color: #00a5f5;
}

.light_blue {
  background-color: #41a1cf;
}

.dashboard_cell:hover > .dashboard_cell_summary {
  margin-top: -190px;
}

.dashboard_cell:hover {
  -webkit-box-shadow: 0px 9px 44px -12px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 44px -12px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 44px -12px rgba(0, 0, 0, 0.75);
}

.dashboard_cell_details {
  height: 100%;
}

.dashboard_cell_summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  transition: all 200ms ease-in-out;
}

.big_number {
  font-size: 5em;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  margin-top: 10px;
}

.summary_subtitle {
  color: white;
  font-weight: bold;
  margin-top: 9px;
}

.details_header {
  width: 100%;
  padding: 10px;
  font-weight: bold;
  color: white;
}

.details_contents {
  padding: 10px;
  width: 100%;
  height: 78%;
  overflow-y: scroll;
}

.details_contents a:hover {
  cursor: pointer;
}

.dashboard_cell_country {
  flex: 1 0 auto;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-left: 5px;
  margin-right: 5px;
  min-height: 190px;
  max-height: 190px;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 30%;
}

.cell_country_header {
  width: 100%;
  padding: 10px;
  font-weight: bold;
  border-bottom: 1px solid #cccccc;
  flex: 0 0 auto;
  text-align: center;
  display: flex;
}

.cell_country_summary {
  padding: 10px;
  height: 78%;
  transition: all 200ms ease-in-out;
}

.country_summary_list {
  flex: 1 0 auto;
  padding: 10px;
  overflow-y: scroll;
  display: inline-block;
}

.big_flag {
  font-size: 65px;
  top: 5px;
}

.country_summary_list > .status_header {
  font-weight: bold;
}

.expiring_soon {
  color: #ffaa49;
}

.expired {
  color: #ff0606;
}

.pending {
  color: #4f90c3;
}

.active {
  color: #013a68;
}
.country_list {
  padding: 10px;
  overflow-y: scroll;
}

.btnExportClass {
  border: 1px solid #0b3c61;
  border-radius: 16px;
  font-family: Roboto !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #0b3c61 !important;
  width: 120px;
  padding-left: 0px;
  line-height: 17px;
}
.exportUL {
  text-align: right;
}
.dropdown-export {
  display: block !important;
}

.col_country {
  flex: 2 0 105px;
  text-align: left;
  flex-wrap: wrap;
}

.col_exp_soon {
  flex: 1 0 auto;
}

.col_active {
  flex: 0 0 auto;
}

.country_row {
  display: flex;
}

.fa-globe {
  padding-right: 10px !important;
}
.detailcontent_wrapper {
  position: relative;
}
.cursor-pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}
::v-deep .country-dropdown .v-select .open-indicator {
  left: 90%;
}
::v-deep .country-dropdown .v-select .dropdown-toggle {
  width: 100%;
}

@media only screen and (min-width: 1200px) {
  .ml-10 {
    margin-left: 10px;
  }
  .wd-80 {
    width: 120px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .country-dropdown {
    padding-left: 0px;
  }
  .p-m-0 {
    padding: 0px !important;
  }
}
.txt-alg-rt {
  text-align: right;
}
@media (min-width: 1025px) and (max-width: 1150px) {
  .country-dropdown {
    padding-right: 0px;
  }
  .list-title {
    padding-left: 0px;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .p-m-0 {
    padding: 0px !important;
  }
  .wd-110 {
    width: 105px;
  }
  .sm-pl-0 {
    padding-left: 0;
  }
}

@media screen and (max-width: 1024px) {
  .dropdown-container {
    justify-content: unset;
  }
  .country-dropdown {
    max-width: 182px;
  }
}

@media screen and (max-width: 767px) {
  .country-dropdown {
    padding-left: 0px;
    width: 100%;
    max-width: unset;
  }
  .p-m-0 {
    padding: 0px !important;
  }
  .btnExportClass {
    width: 80px;
  }

  .map-controls-container {
    flex-direction: column;
  }

  .dropdown-container {
    flex-direction: column;
    width: 100%;
  }

  .product-container {
    flex-direction: column;
    margin-right: 0;
    width: 100%;
  }

  .country-container {
    flex-direction: column;
    margin-top: 24px;
    width: 100%;
  }

  .controls-container {
    width: 100%;
    margin-top: 24px;
  }

  .clear-button-wrapper {
    width: 100%;
    max-width: 131px;
  }
}
</style>
